import { render, staticRenderFns } from "./sizePicker.vue?vue&type=template&id=3480b031&scoped=true"
import script from "./sizePicker.vue?vue&type=script&lang=js"
export * from "./sizePicker.vue?vue&type=script&lang=js"
import style0 from "./sizePicker.vue?vue&type=style&index=0&id=3480b031&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3480b031",
  null
  
)

export default component.exports